import { inject, Pipe, PipeTransform } from '@angular/core';
import { InvoicingService } from '../../core/services/invoicing.service';

@Pipe({
  name: 'paymentMethod'
})
export class PaymentMethodPipe implements PipeTransform {

  private invoicingService = inject(InvoicingService);

  /**
   * Merchant-facing label for a payment method. Origin (prepayment, pay link, direct)
   * is not shown — e.g. online MB Way and in-store MB Way both read "MB Way".
   */
  transform(value: unknown, isOnlinePayment?: boolean): unknown {
    const allMethods = [
      ...this.invoicingService.paymentMethods,
      ...this.invoicingService.chargingMethods,
    ];

    const inPersonLabel = allMethods.find((m) => m.value === value && !m.isOnlinePayment);
    if (inPersonLabel) {
      return inPersonLabel.label;
    }

    const exactMatch = allMethods.find(
      (m) => m.value === value && m.isOnlinePayment === isOnlinePayment,
    );
    if (exactMatch) {
      return exactMatch.label;
    }

    const fallback = allMethods.find((m) => m.value === value);
    return fallback?.label ?? null;
  }
}
